
import { Camera, Upload } from "lucide-react";

interface AvatarUploadButtonProps {
  avatarUrl: string | null;
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  isUploading: boolean;
}

export function AvatarUploadButton({ 
  avatarUrl, 
  onUpload, 
  isUploading 
}: AvatarUploadButtonProps) {
  return (
    <div className="flex flex-col gap-2 items-center">
      <label htmlFor="avatar-upload">
        <div className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md cursor-pointer">
          {avatarUrl ? <Camera className="h-4 w-4" /> : <Upload className="h-4 w-4" />}
          <span>{avatarUrl ? 'Trocar imagem' : 'Fazer upload'}</span>
        </div>
      </label>
      <input
        id="avatar-upload"
        type="file"
        accept="image/*"
        onChange={onUpload}
        disabled={isUploading}
        className="hidden"
      />
      <p className="text-xs text-muted-foreground text-center max-w-xs">
        Formatos permitidos: JPG, PNG e GIF. Tamanho máximo: 2MB.
      </p>
    </div>
  );
}
